/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function toggles() {
  $('.toggles__toggle').hide();
  $('.toggleWrap').on('click tap', function () {
    $(this).toggleClass('active');
    $(this).find('.toggles__toggle').slideToggle();
  });
}
